// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.archive-feed-card {
    background: transparent;
    border-radius: 10px;
    padding: 12px;
    border: 1px solid var(--border-color, rgb(52, 51, 51));
    /* box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); */
    width: 100%; /* optional, but harmless */
    box-sizing: border-box;
  }`, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Styles/UAArchiveContent.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sDAAsD;IACtD,gDAAgD;IAChD,WAAW,EAAE,2BAA2B;IACxC,sBAAsB;EACxB","sourcesContent":[".archive-feed-card {\n    background: transparent;\n    border-radius: 10px;\n    padding: 12px;\n    border: 1px solid var(--border-color, rgb(52, 51, 51));\n    /* box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1); */\n    width: 100%; /* optional, but harmless */\n    box-sizing: border-box;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
